<template>
  <div>
    <div
      class="col-sm-4 col-md-2"
      @click.right="notShowContextMenu"
      style="border:0px solid green;"
    >
      <!--:style="{backgroundColor: item.bg_color}"-->
      <div
        class="bg-primary"
        @click.right="getDataList({'id':item.id, 'status':item.booking_status, 'booking_id':item.booking_id, 'cleaning_status':item1[item.id], 'cleaning_status_id':item2[item.id]})"
        style="margin-bottom:10px;border:0px solid red;"
        :style="{backgroundColor: item.bg_color, border: item.border_bedroom}"
      >
        <div style="border:0px solid cyan;display:flex;">
          <div style="border:0px solid red;width:40%;float:left;text-align:right;margin-top:3px;">
            <i class="fa fa-group"></i>
          </div>
          <!--Icon-->
          <div
            style="border:0px solid red;width:60%;float:left;text-align:right;height:auto;margin-top:3px;margin-right:7px;"
          >
            <a
              class="btn btn-social-icon btn-bitbucket"
              style="width:22px;height:18px;margin:0.5px;"
            >
              <i class="fa fa-refresh" style="line-height: 17px;font-size: 0.8em;"></i>
            </a>
            <a
              class="btn btn-social-icon btn-bitbucket"
              style="width:22px;height:18px;margin:0.5px;"
            >
              <i class="fa fa-print" style="line-height: 17px;font-size: 0.8em;"></i>
            </a>
            <a class="btn btn-social-icon btn-flickr" style="width:22px;height:18px;margin:0.5px;">
              <i class="fa fa-calendar" style="line-height: 17px;font-size: 0.8em;"></i>
            </a>
          </div>
        </div>
        <!--Apartment Name-->
        <div style="text-align:center;margin-top:5px;margin-bottom:10px;">
          Phòng
          <span style="font-weight:bold;color:black">{{item.apartment_code}}</span>
        </div>
        <div
          @click="openBookingDetail(item)"
          style="text-align:center;font-size: 0.8em;margin-bottom:5px;cursor:pointer;"
        >{{item.booking_code}}</div>
        <div
          style="text-align:center;font-size: 0.8em;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;padding:2px;"
          :title="item.customer_name"
        >{{item.customer_name}}</div>
        <div style="border:0px solid red;text-align:center;height:auto;">
          <i
            class="fa fa-calendar-check-o"
            style="line-height: 17px;font-size: 0.9em;margin-bottom:5px;"
          >&nbsp;{{item.checkin_datetime}}</i>
          <br />
          <i
            class="fa fa-calendar-times-o"
            style="line-height: 17px;font-size: 0.9em;"
          >&nbsp;{{item.checkout_datetime}}</i>
        </div>
        <!--Button-->
        <div style="text-align:center;margin-top:10px;">
          <button
            v-show="item.booking_status != BookingStatusEnum.CONFIRMED && item.booking_status != BookingStatusEnum.ONBOARD && item.booking_status != BookingStatusEnum.DEPOSIT"
            @click="apartmentBooking(item.id)"
            class="btn btn-sm btn-bitbucket"
            style="line-height:1;margin-bottom:5px;"
          >{{$t('apartmentbookings.status_booking.booking')}}</button>
          <button
            v-show="item.booking_status == BookingStatusEnum.ONBOARD"
            @click="onCheckOut(item)"
            class="btn btn-sm btn-bitbucket"
            style="line-height:1;margin-bottom:5px;"
          >{{$t('apartmentbookings.status.checkout')}}</button>
          <!-- <button class="btn btn-sm btn-bitbucket" style="line-height:1;">Checkin</button> -->
          <button
            v-show="item.booking_status == BookingStatusEnum.CONFIRMED || item.booking_status == BookingStatusEnum.DEPOSIT"
            @click="onCheckIn(item.booking_id)"
            class="btn btn-sm btn-bitbucket"
            style="line-height:1;margin-bottom:5px;"
          >{{$t('apartment.reservations.confirm_checkin')}}</button>
        </div>
        <div :class="item.border_bedroom_triangle">
          <div
            style="bottom: 10px;text-align: right;position: absolute;margin-left: 4px;"
          >{{item.bedroom_count > 0 ? item.bedroom_count : 0 }}</div>
          <!--<div style="text-align:center;margin-bottom:15px;">&nbsp;</div>-->
        </div>
        <div
          v-show="item1[item.id] == 1 || item1[item.id] == 2 || item1[item.id] == 4 || item1[item.id] == 5"
        >
          <div style="bottom: 15px;text-align: right;position: absolute;margin-left:65%;">
            <i class="fa fa-paint-brush" style="color:#ffffff"></i>
          </div>
          <!--<div style="text-align:center;margin-bottom:15px;">&nbsp;</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/lib/utils";
import BookingStatusEnum from "@/enum/bookingStatusEnum";

export default {
  name: "booking",
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    item1: {
      type: Array,
      default: () => []
    },
    item2: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      BookingStatusEnum: BookingStatusEnum,
      selected: ""
    };
  },
  methods: {
    openBookingDetail: function(apartment_booking) {
      if (!utils.isNull(apartment_booking.booking_id)) {
        // [Khanh] Open booking details instead of booking preview
        this.$emit("openBooking", apartment_booking.booking_id);
      }
    },
    apartmentBooking: function(apartment_id) {
      this.$emit("apartmentbooking", apartment_id);
    },
    onCheckOut: function(item) {
      this.$emit("onCheckOut", item);
    },
    onCheckIn: function(booking_id) {
      this.$emit("quickActions", booking_id);
    },
    getDataList: function(data_dict) {
      this.$emit("getdatalist", data_dict);
    },
    notShowContextMenu: function() {
      this.$emit("notshowcontextmenu");
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.select2-search--inline,
.select2-search__field {
  width: 1em;
}
.select2-container--default .select2-selection--multiple {
  background-color: white;
  border-color: rgb(210, 214, 222) !important;
  border-radius: 4px;
  cursor: text;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  margin-top: 0px;
}
.select2-container--default .select2-selection--multiple {
  /*color border */
  border-color: #d2d6de;
  padding: 1px 8px;
}
/* .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-search__field{
    padding: 1px 8px;
    color:#000;
} */

.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice {
  background-color: #00a65a;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice__remove {
  color: #000;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice__remove:hover {
  color: #fff;
}
[class^="select2"] {
  border-radius: 0px !important;
  border-color: #ccc;
  box-shadow: none;
  font-size: 14px;
  color: #555;
  font-family: inherit;
}
::placeholder {
  color: #999;
  opacity: 1;
}
.gradeTriangleFuchsia {
  border-bottom: 30px solid fuchsia !important;
  border-right: 30px solid transparent !important;
  bottom: 0;
  right: 0;
  width: 0px;
  height: 0px;
}
.gradeTriangleNavy {
  border-bottom: 30px solid navy !important;
  border-right: 30px solid transparent !important;
  bottom: 0;
  right: 0;
  width: 0px;
  height: 0px;
}
.gradeTriangleChocolate {
  border-bottom: 30px solid chocolate !important;
  border-right: 30px solid transparent !important;
  bottom: 0;
  right: 0;
  width: 0px;
  height: 0px;
}
.gradeTriangleTransparent {
  border-bottom: 30px solid black !important;
  border-right: 30px solid transparent !important;
  bottom: 0;
  right: 0;
  width: 0px;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/LTEBooking.vue